import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffsCerficationsMultipleFilter extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      certifications_ids: '',
      certifications_list: [],
      certifications_index: [],
      staff_certifications: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchStaffCertifications = this.searchStaffCertifications.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  
  searchStaffCertifications(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      certifications: this.state.certifications_ids,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulantes/filtro_multiplo_certificados', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data.staffs});
          self.setState({certifications_index: responseJson.data.certifications});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificados/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <form onSubmit={this.searchStaffCertifications}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.CertificadosDeFiltroMultiplo.formulario.Certificados}:</label>
              <Select
                className=""
                name="certifications_ids"
                value={this.state.certifications_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.Tripulantes.CertificadosDeFiltroMultiplo.formulario.placeholder.SelecionarCertificados}
                onChange={this.handleSelectChange.bind(this, 'certifications_ids')}
                options={this.state.certifications_list}
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.general.buscar}</button>
        </div>
      </form>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>{this.locale.Tripulantes.CertificadosDeFiltroMultiplo.tabela.Tripulante}</th>
              <th>{this.locale.Tripulantes.CertificadosDeFiltroMultiplo.tabela.Matricula}</th>
              {Object.keys(self.state.certifications_index).map(function(ct) {
                return (
                  <th>{self.state.certifications_index[ct].certification_name}</th>
                );
              })}
            </tr>
          </thead>
          <tbody id="grupo-certificados">
            {Object.keys(self.state.staff_certifications).map(function(k) {
              return (
                <tr>
                  <td>
                    {self.state.staff_certifications[k].name}
                  </td>
                  <td>
                    {self.state.staff_certifications[k].inscription}
                  </td>
                  {Object.keys(self.state.certifications_index).map(function(sct) {
                    return (
                      <td>
                        {(self.state.staff_certifications[k]['certifications'][sct].expire_status_str === "Expirado" || self.state.staff_certifications[k]['certifications'][sct].expire_status_str === "Não tem") ? <span className="label label-danger">{self.state.staff_certifications[k]['certifications'][sct].expire_str}</span> : <span className="label label-success">{self.state.staff_certifications[k]['certifications'][sct].expire_str}</span>}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default StaffsCerficationsMultipleFilter;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsCerficationsMultipleFilter.js